const Routes = {
  getRoutes: `ExternalSale/routes`,
};

export default Routes;
